import tw from "twin.macro";

export const Wrapper = tw.div`
	border border-shade-40 border-2 rounded-8 flex justify-between items-center px-12 py-12 gap-16 cursor-pointer`;

export const FileInfoWrapper = tw.div`
	flex flex-col gap-4 flex-1 pl-[0.5rem]`;
